import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18NextPipe } from 'angular-i18next';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss'],
  standalone: false
})
export class EditUserComponent implements OnInit {

  userId: number | null = null;
  isNewUser = false;
  pageHeading = '';

  BreadcrumbsLink = [
    { label: 'Home', url: '/' },
    { label: 'Users', url: '/users/users' },
    { label: '', url: '' }
  ];

  constructor(
    private route: ActivatedRoute,
    private i18n: I18NextPipe
  ) {}

  ngOnInit(): void {
    const userIdParam = this.route.snapshot.paramMap.get('userId');
    this.userId = userIdParam ? Number(userIdParam) : null;
    this.isNewUser = !this.userId;

    if (this.isNewUser) {
      this.pageHeading = this.i18n.transform('users:newuser_heading') || 'Add User';
      this.BreadcrumbsLink[2].label = this.pageHeading;
    } else {
      const headingRaw = this.i18n.transform('users:edituser_heading') || 'Edit User';
      this.pageHeading = headingRaw.replace('{0}', String(this.userId));
      this.BreadcrumbsLink[2].label = headingRaw
        .replace(/<[^>]*>/g, '')
        .replace('{0}', String(this.userId));
    }
  }
}
